import styled from "styled-components";

export const Wrapper = styled.div`
  .dashboard-main{
    padding: 30px 0px 0 0px;
    display: flex;
    justify-content: space-between;
    margin-top: -30px;
  }
  .h30{
    height: 30px;
  }
  .whitbg{
    background: #fff;
    color:#000;
  }
  .container{
    padding: 24px 0px;
  }
   .user-info{
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 20px;
    color: #000;
    .left{
      display: flex;
      gap: 10px;
      .yellow-left-cards{
        flex: 0 0 35%;
        background: #FFF5B2;
        padding: 16px;
        display: flex;
        box-shadow: 0px 1px 3px #DCBD7652;
        border-radius: 10px;
        gap: 15px;
        position: relative;
        .box {
          flex-direction: row;
          justify-content: space-between;
          padding-right: 15px;
        }
        label {
          white-space: nowrap;
        }
        span {
          margin-top: 8px !important;
        }
      }
      .white-left-cards {
        flex: 1;
        .box{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding-right: 15px;
          .inner-box {
            align-items: center;
            img {
              background: rgb(255, 222, 224);
              padding: 0.5rem;
              border-radius: 1.15rem;
            }
          }
        }
        .right{
          height: 100%;
        }
      }      
    }
    .box{
      flex: 1;
      border-right: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:last-child{
        border: none;
      }
      .inner-box{
        display: flex;
        gap: 10px;
        svg{
          height: 40px;
          width: 40px;
        }
      }
      label{
        font-size: 13px;
        font-weight: 500;
      }
      span{
        font-size: 18px;
        margin-top: 30px;
        display: block;
        font-weight: 500;
      }
    }

    .right{
      flex: 0 0 67%;
      display: flex;
      padding: 16px;
      background: #fff;
      box-shadow: 0px 1px 3px #00000021;
      border-radius: 10px;
      gap: 15px;
      .box{
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding-right: 15px;
        .inner-box {
          align-items: center;
        }
        span {
          margin-top: 0;
        }
      }
    }
  }

  .payment{
    display: flex;
    grid-gap: 10px;
    .payment-box{
      flex: 1;
      padding: 16px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      grid-gap: 20px;
      border: 1px solid #D4D4D4;
    }
    .top{
      display: flex;
      grid-gap: 20px;
    }
    .box{
      flex: 1;
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      align-items: center;
      gap: 10px;
      span{
        text-shadow: 0px 1px 0px #00000033;
        padding: 4px 18px;
        border-radius: 15px;
        position: relative;
        &.green{
          background: #03A739;
          color: #fff;
          &:before{
            content: "";
            border-right: 6px solid #03A739;
            border-left: 6px solid transparent;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            position: absolute;
            left: -10px;
            top: 7px;
          }
        }
        &.grey{
          background: #4A4A4A;
          color: #fff;
          &:before{
            content: "";
            border-right: 6px solid #4A4A4A;
            border-left: 6px solid transparent;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            position: absolute;
            left: -10px;
            top: 7px;
          }
        }
        &.red{
          background: #ED141F;
          color: #fff;
          &:before{
            content: "";
            border-right: 6px solid #ED141F;
            border-left: 6px solid transparent;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            position: absolute;
            left: -10px;
            top: 7px;
          }
        }
      }
    }
    .bottom{
      display: flex;
      grid-gap: 20px;
      .box{
        background: #F2F2F2;
        border-radius: 17px;
        padding: 8px;
        box-shadow: 0px 1px 3px #00000021;
        border: 1px solid #D4D4D4;
      }
    }
  }
  .table-container{
    background: #fff;
    padding: 36px;
    box-shadow: 0px 1px 3px #00000021;
    border: 1px solid #D4D4D4;
    border-radius: 10px;
    .top{
      display: flex;
      justify-content: space-between;
    }
  }
`;
